import React, {useEffect, useRef} from 'react'
import { Box, Button, Typography, List, ListItem, ListItemText } from '@mui/material'

import webtexts from '../../../assets/webtexts.json'
import { home4 } from '../../../assets'

import { BackgroundVideo, SectionTitle } from '../../../components';
import { color } from 'framer-motion';
import HomeCareer from '../HomeCareer/HomeCareer';

const HomeAbout = () => {
    const expertise = [
        "Commercial Properties", "Residential Spaces", "Institutional Buildings", "Insdustrial Facilities", "Communal Spaces"
    ]
  return (
    <Box
        sx={{
            width: '100%',
            minHeight: '100vh', // Ensures the container takes up the full viewport height
            overflow: 'hidden',
            position: 'relative',
        }}
    >
        
        
        <Box
            sx={{
                background:'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))',
                width:'100%',
                minHeight:'100vh',
                position: 'relative',
            }}
        >
            <BackgroundVideo
            video={home4}
        />
            <Box
            sx={{
                width:'100%',
                display:'flex',
                flexDirection:'row',
                paddingY:'2rem'
            }}
            >
                <SectionTitle 
                    firstTitleWord='Who' 
                    textStyle={{
                        color:'#fefefe'
                    }}
                    secondTitleWord='we are'
                    secondWordStyle={{
                        color:'var(--color-secondary)'
                    }}
                    linesx={{
                        backgroundColor:'#fefefe'
                    }}
                    sx={{
                        width:'100%'
                    }}
                />

            </Box>
        




        {/* Testing content */}


            <Box
                sx={{
                    marginLeft:'5rem',
                    width:'50%',
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    '@media screen and (max-width:762px)':{
                        margin:'1rem',
                        width:'90%'
                    }
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        fontSize:'2rem',
                        fontFamily:"ITC Avant Garde Gothic",
                        fontStyle:'nomral',
                        textTransform:'uppercase',
                        fontWeight:'1000',
                        color:'#fefefe',
                        marginBottom:'2rem'
                    }}  
                >
                    Pangu <span style={{color:"#59428A"}}>Enterprises</span>
                </Typography>

                <Box>
                    <Typography
                        sx={{
                            textTransform:'',
                            color: '#fefefe',
                            fontFamily:'Gotham'
                        }}
                    >
                        <Typography>{webtexts.aboutHome.text1}</Typography><br />

                        <Typography>
                            Our expertise covers a wide range of services, including:
                            <List
                                dense={true}
                                sx={{
                                    listStyleType: 'disc',
                                    marginLeft:'2rem'
                                }}
                            >
                                {expertise.map((item, index) => (
                                    <ListItem
                                    sx={{ display: 'list-item' }}
                                >
                                    <ListItemText primary={item} />
                                </ListItem>
                                ))}
                            </List>
                        </Typography>

                        <Typography>{webtexts.aboutHome.text2}</Typography> <br />
                        <Typography>{webtexts.aboutHome.text3}</Typography>
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display:'flex',
                        width:'50%',
                        justifyContent:'right',
                        marginY:'2rem'
                    }}
                >
                    <Button variant='outlined'
                    href='/about'
                        sx={{
                            borderRadius:'0',
                            color:'#fefefe',
                            borderColor:'#fefefe',
                            '&:hover':{
                                backgroundColor:'var(--color-secondary)'
                            }
                        }}
                    >About Us</Button>
                </Box>
            </Box>
        </Box>
    </Box>
  )
}

export default HomeAbout